import React from 'react';

export function EmptySong() {
  return (
    <div>
      <br/><br/><br/><br/><br/><br/>
    </div>
  )
}
export function RosalinaObservatory() {
  return (
    <>
    <div>
      Easy<br/><br/>
      M D E J Q K F J G K B K J B K J A G N G D<br/>
      M D E J Q K F G K Y K Y R R E D E Q J K<br/>
      Repeat Chorus<br/>
      Y K Q Y Q P Y K Y K Q Y Q P Y 3 P Y K Q Y Q P Y K G J K Q<br/>
      Repeat Whole
    </div>
    </>
  );
}
export function Underground() {
  return (
    <>
    <div>
      Hard<br/><br/>
      J Q Y P 3 P 3 P 2 3 5<br/>
      ( L 2 1 P I Y R E T E Q )<br/>
      J Q Y P 3 P 3 P 3 2 P 2 E Q E I Y I<br/>
      ( 2 O Y I O I)<br/>
      J Q Y P 3 I I 3 I 3 5 3 5<br/>
      ( 8 0 8 6 5 2 5 2 I Y I Y E)<br/>
      J Q Y P 3 5 I 5 I 8 7 8 7 5 3<br/>
      B M S G<br/>
      3 P 3 7 5 3 2 3 5
    </div>
    </>
  );
}
export function SongOfStorms() {
  return (
    <>
    <div>
      Easy<br/><br/>
      K Y Y Q I W O O Q I K Y Y Q I W O O Q I<br/><br/>
      K W 1 K W 1 3 4 3 4 3 O Y<br/>
      Y K W R Y Y K W R Q<br/>
      K W 1 K W 1 3 4 3 4 3 O Y<br/>
      Y K W R Y Y K<br/>
      Repeat<br/>
    </div>
    </>
  );  
}
export function GreatFairyFountain() {
    return (
      <>
      <div>
        Medium<br/><br/>
        Y K G A R K G A E K G A R K G A<br/>
        R H D N W H D N Q H D N W H D N<br/>
        W F A B Q F A B L F A B Q F A B<br/>
        Q S N C K S N C J S N C K S N C<br/>
        Y K G A R K G A E K G A R K G A<br/>
        U L H D Y L H D T L H D Y L H D<br/>
        O K F A U K F A Y K F A U K F A<br/>
        Y F A B R F A B E F A B Q F A B<br/>
        Repeat
      </div>
      </>
    );  
}
export function SilverLining() {
  return (
    <>
    <div>
      Easy<br/><br/>
      R Y I 1 O O 1 3 I Y Y R W Q W O O I O 1 3 1<br/>
      R Y I 1 O O 1 3 I Y Y R W Q W O O I O K W Q<br/><br/>
      A D G K H H K Q G D D A N B N H H G H K Q K<br/>
      A D G K H H K Q G D D A N B N H Q K H B N B<br/>
    </div>
    </>
  );
}